import { SiteType } from './site-type';

export const environment = {
  fixedCurrency: false,
  siteType: SiteType.BUS,
  production: false,
  euroDate: '2023-01-01',
  paywayUrl: 'https://pgwtest.ht.hr/services/payment/api/authorize-form',
  restUrl: '/public_api/',
  restApi: 'api/',
  restPublic: 'public/',
  wsUrl: '/public_api/ws',
  login: {
    autologin: false,
    username: '',
    password: '',
    businessPremiseId: null,
    terminalId: null
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts